import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SupplierIntegrationsPage } from '@/areas/settings/supplier-integrations/Settings/SupplierIntegrationsPage/SupplierIntegrationsPage';
import { canViewSourcingSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/supplier-api-integrations')({
    staticData: {
        access: { permissions: canViewSourcingSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierIntegrationsPage />;
}
